import * as clientsActions from "../state/client.actions";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { EntityState, EntityAdapter, createEntityAdapter } from "@ngrx/entity";
import { Client, ClientState } from '@core/services/client/client.model';
import * as fromRoot from '../../../features.state';
import { id } from '@swimlane/ngx-datatable';
import { isDataSource } from '@angular/cdk/collections';

export interface AppState extends fromRoot.FeaturesState {
    clients: ClientState;
}

export const clientAdapter: EntityAdapter<Client> = createEntityAdapter<Client>();

export const defaultClient: ClientState = {
    ids: [],
    entities: {},
    selectedClientId: null,
    loading: false,
    loaded: false,
    error: ""
  };
  
  export const initialState = clientAdapter.getInitialState(defaultClient);

  export function ClientsReducer(
    state = initialState,
    action: clientsActions.ClientsAction
  ): ClientState {
    switch (action.type) {

      case clientsActions.ClientActionTypes.LOAD_CLIENTS_SUCCESS: {
        return clientAdapter.setAll(action.payload, {
          ...state,
          loading: false,
          loaded: true
        });
      }

      case clientsActions.ClientActionTypes.LOAD_CLIENTS_FAIL: {
        return {
          ...state,
          entities: {},
          loading: false,
          loaded: false,
          error: action.payload
        };
      }
  
      case clientsActions.ClientActionTypes.LOAD_CLIENT_SUCCESS: {
        return clientAdapter.addOne(action.payload, {
          ...state,
          selectedClientId:action.payload.id
        });
      } 
  
      case clientsActions.ClientActionTypes.LOAD_CLIENT_FAIL: {
        return {
          ...state,
          error: action.payload
        };
      }
  
      case clientsActions.ClientActionTypes.CREATE_CLIENT_SUCCESS: {
      //  const ids = state.ids.slice(0);
             //ids.push(action.payload.id);
             console.log("action.payload.id",action.payload)
        return clientAdapter.addOne(action.payload, {
          ...state,
          selectedClientId: action.payload.id
        });
      }

      case clientsActions.ClientActionTypes.CREATE_CLIENT_FAIL: {
        return {
          ...state,
          error: action.payload
        };
      }
  
      case clientsActions.ClientActionTypes.UPDATE_CLIENT_SUCCESS: {
        return clientAdapter.updateOne(action.payload, state);
      }

      case clientsActions.ClientActionTypes.UPDATE_CLIENT_FAIL: {
        return {
          ...state,
          error: action.payload
        };
      }
  
      case clientsActions.ClientActionTypes.UPDATE_CLIENT_TOBE_INACTIVE_SUCCESS: {
        return clientAdapter.updateOne(action.payload, state);
      }

      case clientsActions.ClientActionTypes.UPDATE_CLIENT_TOBE_INACTIVE_FAIL: {
        return {
          ...state,
          error: action.payload
        };
      } 
       
      default: {
        return state;
      }
    }
  }
  
  const getClientFeatureState = createFeatureSelector<ClientState>("clients");
  
  export const getClients = createSelector(
      getClientFeatureState,
      clientAdapter.getSelectors().selectAll
  );
  
  export const getClientsLoading = createSelector(
      getClientFeatureState,
     (state: ClientState) => state.loading
  );
  
  export const getClientsLoaded = createSelector(
     getClientFeatureState,
     (state: ClientState) => state.loaded
  );
  
  export const getError = createSelector(
      getClientFeatureState,
     (state: ClientState) => state.error
  );
  
  export const getCurrentClientId = createSelector(
      getClientFeatureState,
      (state: ClientState) => state.selectedClientId
  );

  export const getCurrentClient = createSelector(
      getClientFeatureState,
      getCurrentClientId,
      state => state.entities[state.selectedClientId]
  );
